import React, {useEffect} from 'react';
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer';
import Head from "../components/Head";
import Avatar from "../components/Avatar";
import avatars from "../data/avatarData";

function Team() {
    // Animation effect for form elements
    useEffect(() => {
        const animateFormElements = () => {
            const elements = document.querySelectorAll('.animate-in');

            elements.forEach((element, index) => {
                setTimeout(() => {
                    element.classList.add('show');
                }, 100 * index);
            });
        };

        // Run animation after a short delay
        setTimeout(animateFormElements, 200);
    }, []);

  return (
      <>
        <Head pageTitle="AMR - Team" />
        <NavigationBar/>

        <style jsx="true">{`
            /* Animation styles */
            .animate-in {
                opacity: 0;
                transform: translateY(20px);
                transition: opacity 0.5s ease, transform 0.5s ease;
            }

            .animate-in.show {
                opacity: 1;
                transform: translateY(0);
            }
            
          /* Team page styles with proper spacing to avoid header overlap */
          body {
            background-color: #ffffff;
          }

          .page-container {
            max-width: 100%;
            overflow-x: hidden;
          }

          .team-section {
            padding: 0 0 100px;
            background-color: #ffffff;
            position: relative;
            /* Added extra top padding to account for fixed header */
            margin-top: 120px;
          }

          .team-header {
            position: relative;
            margin-bottom: 80px;
            text-align: center;
            padding-top: 50px; /* Extra padding at top */
          }

          .team-title {
            font-size: 40px;
            font-weight: 700;
            color: #000;
            position: relative;
            display: inline-block;
            margin: 0;
            padding: 0 20px;
          }

          .team-title::before,
          .team-title::after {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 80px;
            background-color: #DBA800;
          }

          .team-title::before {
            left: -15px;
          }

          .team-title::after {
            right: -15px;
          }

          .team-container {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            max-width: 1200px;
            margin: 0 auto;
            gap: 120px;
            padding: 0 20px;
          }

          /* Mobile responsiveness */
          @media (max-width: 992px) {
            .team-container {
              gap: 60px;
            }

            .team-title {
              font-size: 36px;
            }

            .team-title::before,
            .team-title::after {
              height: 60px;
            }
          }

          @media (max-width: 768px) {
            .team-section {
              margin-top: 100px;
            }

            .team-header {
              padding-top: 30px;
            }

            .team-container {
              gap: 40px;
            }
          }

          @media (max-width: 576px) {
            .team-header {
              margin-bottom: 50px;
              padding: 20px 0;
            }

            .team-title {
              font-size: 30px;
            }

            .team-title::before,
            .team-title::after {
              height: 50px;
            }

            .team-container {
              gap: 30px;
            }
          }
        `}</style>

        <div className="page-container">
          <section className="team-section">
            <div className="team-header animate-in py-5">
              <h1 className="team-title">Our Team</h1>
            </div>

            <div className="team-container animate-in">
                {avatars.map((avatar) => (
                    <Avatar
                        imageSrc={avatar.memberImage}
                        imageAlt={avatar.memberImageAlt}
                        avatarName={avatar.memberName}
                        avatarTitle={avatar.memberTitle}
                    />
                ))}
            </div>
          </section>
        </div>

        <Footer/>
      </>
  );
}

export default Team;